import { Navigate, useLocation } from "react-router-dom"
import * as O from "fp-ts/Option"
import { useAuth } from "@/hooks/use-auth"
import { usePermissions } from "@/hooks/use-permissions"
import { useTenantClosed } from "@/lib/tenant-closed"
import { TenantClosedPage } from "@/components/TenantClosedPage"
import { Loader2 } from "lucide-react"

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const { canRead } = usePermissions()
  const closure = useTenantClosed()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    )
  }

  if (!isAuthenticated) {
    const redirectPath = location.pathname + location.search
    const redirectTo = `/login?redirect=${encodeURIComponent(redirectPath)}`
    return <Navigate to={redirectTo} replace />
  }

  // Organisme fermé : l'administrateur garde l'app, les autres une page unique.
  if (O.isSome(closure) && !canRead("admin")) {
    return <TenantClosedPage closure={closure.value} />
  }

  return <>{children}</>
}
